import React, { useEffect } from "react";
import InnerBanner from "../Components/InnerBanner";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPageData,
  resetMenuData,
} from "../../../redux/slice/homeSlice/sliceHome";
import Spinner from "../Components/Spinner";
import { Link, useNavigate } from "react-router-dom";

const SubMenuPage = ({ title, id }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPageData(`submenu-details/${id}`));
    return () => {
      dispatch(resetMenuData());
    };
  }, [dispatch, id]);

  const { pageData, loading } = useSelector((state) => state.sliceHome);
  if (loading) {
    // return <div className="related-link-loader">Loading...</div>;
    return <Spinner />;
  }
  return (
    <>
      <div className="inner-pg">
        <div className="breadcrumbarea breadcrumb-bg">
          <div className="container">
            <div className="row m-0">
              <div className="col-12 col-sm-12 col-md-12 p-0 mob-ver-p">
                <div className="headingtitle">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        {title}
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="main-content-area">
          <div className="container">
            <div className="row">
              <div className="title-area">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="page-title">
                        {pageData.data && pageData.data.category_name}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="inner-area">
                <table
                  border="1"
                  cellPadding="1"
                  cellSpacing="1"
                  width={"100%"}
                >
                  <thead>
                    <tr>
                      <td>
                        <strong>Sr.</strong>
                      </td>
                      <td>
                        <strong>Title</strong>
                      </td>
                      <td>
                        <strong>Action</strong>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {pageData?.data?.downloads?.length > 0 ? (
                      pageData?.data?.downloads.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.document_title}</td>
                          <td>
                            {item.file_url ? (
                              <a href={item.file_url} target="_blank">
                                Download
                              </a>
                            ) : item.website_link ? (
                              <a href={item.website_link} target="_blank">
                                Link
                              </a>
                            ) : (
                              <></>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} className="text-center">
                          No data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubMenuPage;
